module.exports = __webpack_public_path__ + "static/media/benchmark-bkg-2.9e3b0951.svg";